export const PHONE_FORM_BUTTON_TEXT = "CONTINUE";

export const OTP_FORM_BUTTON_TEXT = "LOGIN";

export const NAME_FORM_LABEL = "What should we call you?";
export const NAME_FORM_BUTTON_TEXT = "Let's go!";
